

export const mutations = {
  SET_COMPANY: (state, payload) => {
    state.company = payload
  },
}
